// Broking.js

import React, { useState,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../../../components/footer/Footer.js";
import Paper from "@mui/material/Paper";
import TopButton from "../../../components/topButton/TopButton.js";
import "./Broking.css";
import Navigationbar from "../../../components/header/Navigationbar.jsx";
import Model from "../../../containers/Model/Model.jsx";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../../contact/WhatsAppCard.jsx";

const Broking = (props) => {
  const theme = props.theme;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="educaton-main">
      <Navigationbar theme={theme} />
      <Paper elevation={4}>
        <div className="basic-education1">
          <Model open={isModalOpen} onClose={handleCloseModal} />
          <div className="basic-education-services">
            <div className="broking-equities">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-equities-text">
                    <p className="broking-equities-text-header">
                      Equities & Derivatives
                    </p>
                    <p className="broking-equities-text-main">
                      Equities represent ownership in a company and are commonly
                      known as stocks or shares.Shareholders have ownership rights,
                      entitling them to a portion of the company's assets and
                      earnings.Returns on equities include dividends and capital
                      appreciation.Equity investments carry market risk, and returns
                      are tied to the company's performance.
                    </p>
                    <p className="broking-equities-text-main">
                      Derivatives are financial contracts whose value is derived
                      from an underlying asset, index, or reference rate.Includes
                      options, futures, swaps, and forwards.Derivatives are used for
                      risk management, speculation, and hedging.Derivatives often
                      allow investors to control a larger position with a smaller
                      upfront investment.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-equities-text">
                    <p className="broking-equities-text-header">
                      Equities & Derivatives
                    </p>
                    <p className="broking-equities-text-main">
                      Equities represent ownership in a company and are commonly
                      known as stocks or shares.Shareholders have ownership rights,
                      entitling them to a portion of the company's assets and
                      earnings.Returns on equities include dividends and capital
                      appreciation.Equity investments carry market risk, and returns
                      are tied to the company's performance.
                    </p>
                    <p className="broking-equities-text-main">
                      Derivatives are financial contracts whose value is derived
                      from an underlying asset, index, or reference rate.Includes
                      options, futures, swaps, and forwards.Derivatives are used for
                      risk management, speculation, and hedging.Derivatives often
                      allow investors to control a larger position with a smaller
                      upfront investment.
                    </p>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-equities-card-main">
                    <div className="broking-equities-card">
                      <img
                        src='/assets/images/Equities & Derivatives.jpg'
                        className="broking-equities-card-img-top"
                        alt="..."
                      />
                      <div className="broking-equities-card-body">
                        <h5
                          className="broking-equities-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Equities &Derivatives
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                ) : (
                <Zoom>
                  <div className="broking-equities-card-main">
                    <div className="broking-equities-card">
                      <img
                        src='/assets/images/Equities & Derivatives.jpg'
                        className="broking-equities-card-img-top"
                        alt="..."
                      />
                      <div className="broking-equities-card-body">
                        <h5
                          className="broking-equities-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Equities &Derivatives
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-commodity">
            {isScrollingUp && animationShown ? (
              <> 
                <div className="broking-commodity-card-main">
                  <div className="broking-commodity-card">
                    <img
                      src='/assets/images/Commodity.jpg'
                      className="broking-commodity-card-img-top"
                      alt="..."
                    />
                    <div className="broking-commodity-card-body">
                      <h5
                        className="broking-commodity-card-title"
                        style={{ paddingBottom: "5px" }}
                      >
                        Commodity
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              ) : (
                <Zoom>
                  <div className="broking-commodity-card-main">
                    <div className="broking-commodity-card">
                      <img
                        src='/assets/images/Commodity.jpg'
                        className="broking-commodity-card-img-top"
                        alt="..."
                      />
                      <div className="broking-commodity-card-body">
                        <h5
                          className="broking-commodity-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Commodity
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-commodity-text">
                    <p className="broking-commodity-text-header">Commodity</p>
                    <p className="broking-commodity-text-main">
                      Commodity finance refers to the financial instruments and
                      services designed to facilitate the production, trade, and
                      consumption of physical goods, known as commodities. This area
                      of finance plays a crucial role in supporting the global
                      supply chain for raw materials and primary goods.
                    </p>
                    <p className="broking-commodity-text-main">
                      Involves providing funding and financial instruments to
                      facilitate the buying and selling of commodities
                      internationally.Financing to help businesses hold and manage
                      their commodity inventories.Hedging tools are often employed
                      to mitigate price volatility and currency risks associated
                      with commodity transactions.
                    </p>
                  </div>
                </>
                ) : (
                <Zoom>
                  <div className="broking-commodity-text">
                    <p className="broking-commodity-text-header">Commodity</p>
                    <p className="broking-commodity-text-main">
                      Commodity finance refers to the financial instruments and
                      services designed to facilitate the production, trade, and
                      consumption of physical goods, known as commodities. This area
                      of finance plays a crucial role in supporting the global
                      supply chain for raw materials and primary goods.
                    </p>
                    <p className="broking-commodity-text-main">
                      Involves providing funding and financial instruments to
                      facilitate the buying and selling of commodities
                      internationally.Financing to help businesses hold and manage
                      their commodity inventories.Hedging tools are often employed
                      to mitigate price volatility and currency risks associated
                      with commodity transactions.
                    </p>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-currency">
               {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-currency-text">
                    <p className="broking-currency-text-header">Currency</p>
                    <p className="broking-currency-text-main">
                      Currency finance, also known as forex finance or foreign
                      exchange finance, refers to financial activities and
                      instruments that involve the exchange of currencies. It plays
                      a pivotal role in international trade, investment, and
                      financial markets.{" "}
                    </p>
                    <p className="broking-currency-text-main">
                      The buying and selling of currencies to take advantage of
                      fluctuations in exchange rates.Strategies employed by
                      businesses and investors to mitigate the risks associated with
                      currency fluctuations.Financial instruments such as currency
                      futures and options used for speculative and hedging purposes.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-currency-text">
                    <p className="broking-currency-text-header">Currency</p>
                    <p className="broking-currency-text-main">
                      Currency finance, also known as forex finance or foreign
                      exchange finance, refers to financial activities and
                      instruments that involve the exchange of currencies. It plays
                      a pivotal role in international trade, investment, and
                      financial markets.{" "}
                    </p>
                    <p className="broking-currency-text-main">
                      The buying and selling of currencies to take advantage of
                      fluctuations in exchange rates.Strategies employed by
                      businesses and investors to mitigate the risks associated with
                      currency fluctuations.Financial instruments such as currency
                      futures and options used for speculative and hedging purposes.
                    </p>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-currency-card-main">
                    <div className="broking-currency-card">
                      <img
                        src='/assets/images/Currency.jpg'
                        className="broking-currency-card-img-top"
                        alt="..."
                      />
                      <div className="broking-currency-card-body">
                        <h5
                          className="broking-currency-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Currency
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                ) : (
                <Zoom>
                  <div className="broking-currency-card-main">
                    <div className="broking-currency-card">
                      <img
                        src='/assets/images/Currency.jpg'
                        className="broking-currency-card-img-top"
                        alt="..."
                      />
                      <div className="broking-currency-card-body">
                        <h5
                          className="broking-currency-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Currency
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-depository">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-depository-card-main">
                    <div className="broking-depository-card">
                      <img
                        src='/assets/images/Depository.jpg'
                        className="broking-depository-card-img-top"
                        alt="..."
                      />
                      <div className="broking-depository-card-body">
                        <h5
                          className="broking-depository-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          {" "}
                          Depository
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-depository-card-main">
                    <div className="broking-depository-card">
                      <img
                        src='/assets/images/Depository.jpg'
                        className="broking-depository-card-img-top"
                        alt="..."
                      />
                      <div className="broking-depository-card-body">
                        <h5
                          className="broking-depository-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          {" "}
                          Depository
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-depository-text">
                    <p className="broking-depository-text-header">Depository</p>
                    <p className="broking-depository-text-main">
                      Depository finance refers to financial services and activities
                      related to the establishment and management of depositories. A
                      depository is an organization or institution that holds and
                      facilitates the transfer of financial securities, providing a
                      secure and efficient platform for investors and market
                      participants.
                    </p>
                    <p className="broking-depository-text-main">
                      Safeguarding and holding financial securities in electronic
                      form, eliminating the need for physical
                      certificates.Facilitating the settlement of trades by
                      transferring ownership of securities between buyers and
                      sellers.Converting physical securities into electronic form to
                      enable efficient electronic trading and management.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-depository-text">
                    <p className="broking-depository-text-header">Depository</p>
                    <p className="broking-depository-text-main">
                      Depository finance refers to financial services and activities
                      related to the establishment and management of depositories. A
                      depository is an organization or institution that holds and
                      facilitates the transfer of financial securities, providing a
                      secure and efficient platform for investors and market
                      participants.
                    </p>
                    <p className="broking-depository-text-main">
                      Safeguarding and holding financial securities in electronic
                      form, eliminating the need for physical
                      certificates.Facilitating the settlement of trades by
                      transferring ownership of securities between buyers and
                      sellers.Converting physical securities into electronic form to
                      enable efficient electronic trading and management.
                    </p>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-clearing">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-clearing-text">
                    <p className="broking-clearing-text-header">Clearing</p>
                    <p className="broking-clearing-text-main">
                      Clearing in finance refers to the process of settling
                      financial transactions and ensuring the smooth transfer of
                      assets between buyers and sellers in a financial market. It
                      plays a crucial role in facilitating transparent and efficient
                      trading.
                    </p>
                    <p className="broking-clearing-text-main">
                      An institution or organization that acts as a central
                      counterparty (CCP) to clear and settle trades.Financial
                      institutions that are members of the clearinghouse and
                      facilitate the clearing process for their clients.The
                      clearinghouse verifies and matches the details of trades
                      submitted by market participants.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-clearing-text">
                <p className="broking-clearing-text-header">Clearing</p>
                <p className="broking-clearing-text-main">
                  Clearing in finance refers to the process of settling
                  financial transactions and ensuring the smooth transfer of
                  assets between buyers and sellers in a financial market. It
                  plays a crucial role in facilitating transparent and efficient
                  trading.
                </p>
                <p className="broking-clearing-text-main">
                  An institution or organization that acts as a central
                  counterparty (CCP) to clear and settle trades.Financial
                  institutions that are members of the clearinghouse and
                  facilitate the clearing process for their clients.The
                  clearinghouse verifies and matches the details of trades
                  submitted by market participants.
                </p>
              </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
              <>
                <div className="broking-clearing-card-main">
                  <div className="broking-clearing-card">
                    <img
                        src='/assets/images/clearing.png'
                        className="broking-clearing-card-img-top"
                        alt="..."
                      />
                    <div className="broking-clearing-card-body">
                      <h5
                        className="broking-clearing-card-title"
                        style={{ paddingBottom: "5px" }}
                      >
                        Clearing
                      </h5>
                      <div
                        className="cardbutton"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <button
                          className="broking-applynow"
                          onClick={handleOpenModal}
                        >
                          Apply Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
              ) : (
                <Zoom>
                  <div className="broking-clearing-card-main">
                    <div className="broking-clearing-card">
                      <img
                        src='/assets/images/clearing.png'
                        className="broking-clearing-card-img-top"
                        alt="..."
                      />
                      <div className="broking-clearing-card-body">
                        <h5
                          className="broking-clearing-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Clearing
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-institutional">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-institutional-card-main">
                    <div className="broking-institutional-card">
                      <img
                        src='/assets/images/institutional-broking.webp'
                        className="broking-institutional-card-img-top"
                        alt="..."
                      />
                      <div className="broking-institutional-card-body">
                        <h5
                          className="broking-institutional-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Institutional
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-institutional-card-main">
                    <div className="broking-institutional-card">
                      <img
                        src='/assets/images/institutional-broking.webp'
                        className="broking-institutional-card-img-top"
                        alt="..."
                      />
                      <div className="broking-institutional-card-body">
                        <h5
                          className="broking-institutional-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          Institutional
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-institutional-text">
                    <p className="broking-institutional-text-header">
                      Institutional
                    </p>
                    <p className="broking-institutional-text-main">
                      Institutional finance refers to the provision of financial
                      services and products to large entities, such as corporations,
                      government agencies, and other institutions, by specialized
                      financial institutions. This type of finance caters to the
                      unique needs and complexities of these entities, offering a
                      range of services beyond those provided to individual
                      consumers.{" "}
                    </p>
                    <p className="broking-institutional-text-main">
                      {" "}
                      Banks, investment banks, insurance companies, and other
                      specialized financial entities that offer services tailored to
                      institutional clients.Entities such as pension funds, mutual
                      funds, hedge funds, and sovereign wealth funds that manage
                      large pools of capital on behalf of their constituents.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-institutional-text">
                    <p className="broking-institutional-text-header">
                      Institutional
                    </p>
                    <p className="broking-institutional-text-main">
                      Institutional finance refers to the provision of financial
                      services and products to large entities, such as corporations,
                      government agencies, and other institutions, by specialized
                      financial institutions. This type of finance caters to the
                      unique needs and complexities of these entities, offering a
                      range of services beyond those provided to individual
                      consumers.{" "}
                    </p>
                    <p className="broking-institutional-text-main">
                      {" "}
                      Banks, investment banks, insurance companies, and other
                      specialized financial entities that offer services tailored to
                      institutional clients.Entities such as pension funds, mutual
                      funds, hedge funds, and sovereign wealth funds that manage
                      large pools of capital on behalf of their constituents.
                    </p>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-nri">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-nri-text">
                    <p className="broking-nri-text-header">NRI Business</p>
                    <p className="broking-nri-text-main">
                      NRI (Non-Resident Indian) business finance pertains to
                      financial services and products designed to meet the needs of
                      individuals of Indian origin residing outside India who are
                      involved in business activities. NRIs often engage in business
                      ventures, investments, and financial transactions, and
                      specialized financial services cater to their unique
                      requirements{" "}
                    </p>
                    <p className="broking-nri-text-main">
                      NRIs may participate in various business activities, including
                      entrepreneurship, investments in Indian companies, and
                      partnerships.Financial institutions offer NRI-specific
                      accounts, such as NRE (Non-Resident External) and NRO
                      (Non-Resident Ordinary) accounts, facilitating the management
                      of income and transactions.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-nri-text">
                    <p className="broking-nri-text-header">NRI Business</p>
                    <p className="broking-nri-text-main">
                      NRI (Non-Resident Indian) business finance pertains to
                      financial services and products designed to meet the needs of
                      individuals of Indian origin residing outside India who are
                      involved in business activities. NRIs often engage in business
                      ventures, investments, and financial transactions, and
                      specialized financial services cater to their unique
                      requirements{" "}
                    </p>
                    <p className="broking-nri-text-main">
                      NRIs may participate in various business activities, including
                      entrepreneurship, investments in Indian companies, and
                      partnerships.Financial institutions offer NRI-specific
                      accounts, such as NRE (Non-Resident External) and NRO
                      (Non-Resident Ordinary) accounts, facilitating the management
                      of income and transactions.
                    </p>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-nri-card-main">
                    <div className="broking-nri-card">
                      <img
                        src='/assets/images/NRI.jpg'
                        className="broking-nri-card-img-top"
                        alt="..."
                      />
                      <div className="broking-nri-card-body">
                        <h5
                          className="broking-nri-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          NRI Business
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-nri-card-main">
                    <div className="broking-nri-card">
                      <img
                        src='/assets/images/NRI.jpg'
                        className="broking-nri-card-img-top"
                        alt="..."
                      />
                      <div className="broking-nri-card-body">
                        <h5
                          className="broking-nri-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          NRI Business
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
            </div>
            <div className="broking-fpi">
              {isScrollingUp && animationShown ? (
                <> 
                  <div className="broking-fpi-card-main">
                    <div className="broking-fpi-card">
                      <img
                        src='/assets/images/FPI.png'
                        className="broking-fpi-card-img-top"
                        alt="..."
                      />
                      <div className="broking-fpi-card-body">
                        <h5
                          className="broking-fpi-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          FPI Investments
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-fpi-card-main">
                    <div className="broking-fpi-card">
                      <img
                        src='/assets/images/FPI.png'
                        className="broking-fpi-card-img-top"
                        alt="..."
                      />
                      <div className="broking-fpi-card-body">
                        <h5
                          className="broking-fpi-card-title"
                          style={{ paddingBottom: "5px" }}
                        >
                          FPI Investments
                        </h5>
                        <div
                          className="cardbutton"
                          style={{ display: "flex", gap: "20px" }}
                        >
                          <button
                            className="broking-applynow"
                            onClick={handleOpenModal}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Zoom>
              )}
              {isScrollingUp && animationShown ? (
                <>
                  <div className="broking-fpi-text">
                    <p className="broking-fpi-text-header">FPI Investments</p>
                    <p className="broking-fpi-text-main">
                      Foreign Portfolio Investment (FPI) refers to the investment in
                      financial assets, such as stocks and bonds, in a foreign
                      country by foreign individuals, institutions, or funds. FPI
                      plays a significant role in global capital markets,
                      contributing to international investment diversification.{" "}
                    </p>
                    <p className="broking-fpi-text-main">
                      Foreign investors may buy shares of companies listed on
                      foreign stock exchanges, gaining ownership stakes in these
                      companies.Investment in government and corporate bonds issued
                      by foreign entities to earn fixed income.
                    </p>
                  </div>
                </>
              ) : (
                <Zoom>
                  <div className="broking-fpi-text">
                      <p className="broking-fpi-text-header">FPI Investments</p>
                      <p className="broking-fpi-text-main">
                        Foreign Portfolio Investment (FPI) refers to the investment in
                        financial assets, such as stocks and bonds, in a foreign
                        country by foreign individuals, institutions, or funds. FPI
                        plays a significant role in global capital markets,
                        contributing to international investment diversification.{" "}
                      </p>
                      <p className="broking-fpi-text-main">
                        Foreign investors may buy shares of companies listed on
                        foreign stock exchanges, gaining ownership stakes in these
                        companies.Investment in government and corporate bonds issued
                        by foreign entities to earn fixed income.
                      </p>
                  </div>
                </Zoom>
                )}
            </div>
          </div>
        </div>
      </Paper>
      <Footer theme={props.theme} onToggle={props.onToggle} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </div>
  );
};

export default Broking;
